import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { Accordion } from 'components/accordion'
import { defaultFaqList } from './faqLists'

interface Props {
  faqs?: {
    title: string
    description: string | React.ReactNode
  }[]
}

export const MLPFAQs = ({ faqs = defaultFaqList }: Props) => {
  const { colors, mediaQueries } = useTheme()

  return (
    <FlexBox
      className={css`
        margin: 24px auto 0;
        padding: 60px 24px;
        max-width: 736px;
        width: 100%;
        background-color: ${colors.uiWhite};
        border-radius: 28px;
        overflow: hidden;
        ${mediaQueries.mobileL} {
          margin-top: 160px;
          padding: 60px;
        }
      `}
      flexDirection="column"
      centerAll
    >
      <Text
        tag="h3"
        type="header"
        sizing="M"
        color={colors.uiGraphite}
        align="center"
      >
        Frequently Asked Questions
      </Text>
      <div
        className={css`
          width: 100%;
        `}
      >
        {faqs.map((faq, i) => (
          <Accordion key={i} title={faq.title}>
            <Text type="body" sizing="M" color={colors.uiGraphite}>
              {faq.description}
            </Text>
          </Accordion>
        ))}
      </div>
    </FlexBox>
  )
}
